import DateUtils from '@/mixins/DateStrings.js'
import apiSale from '@/services/API/Sale'
import axios from 'axios'
import { clone } from 'lodash'
import printerApi from '@/services/printerApi'
import { dateToYYYYMMDDHHmmSS } from '../../../services/JSUtils'

const setSale = function({ commit }, salePayLoad) {
    commit('SET_SALE', salePayLoad)
}

const setPayment = function({ commit }, paymentPayLoad) {
    commit('SET_PAYMENT', paymentPayLoad)
}

const setPaymentArray = function({ commit }, payload) {
    commit('SET_PAYMENT_ARRAY', payload)
}

const setPaymentMethod = function({ commit }, id) {
    commit('SET_PAYMENT_METHOD', id)
}
const setSaleDetails = function({ commit }, payload) {
    commit('SET_SALE_DETAILS', payload)
}

const resetCashDeskState = function({ commit }) {
    commit('RESET')
}

const setSaleType = function({ commit }, id) {
    commit('SET_POS_SALE_TYPE', id)
}

const fetchSaleCustomer = async function({}, ticketCode) {
    let response = await apiSale.fetchSale(ticketCode)
    return response
}

//FIXME: Integration only, remove on production
const printVoucher = async function({}, url) {
    if (!url) return
    const fileName = 'factura.txt'
    const linkSource = `${url}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = fileName
    const win = window.open(url)
    await setTimeout(() => {
        win.close()
    }, 2000)
}

const reprintDTE = async function({ commit }, dte) {
    if (!dte) return
    const route =
        process.env.VUE_APP_API_ROUTE + '/sl_sale_invoice/' + dte.id + '/pdf'
    if (dte.isTicket)
        route =
            process.env.VUE_APP_API_ROUTE + '/sl_sale_ticket/' + dte.id + '/pdf'
    let response = await axios.get(route, { responseType: 'blob' })

    const linkSource = URL.createObjectURL(response.data)
    const downloadLink = document.createElement('a')
    const fileName = `${dte.number}-${
        dte.isTicket ? 'BOLETA' : 'FACTURA'
    }_ELECTRONICA.pdf`
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
}

const annulSale = async function({}, payload) {
    return await apiSale.annulSale(payload)
}

const setPaymentDetail = function({ commit }, payload) {
    commit('SET_PAYMENT_DETAIL', payload)
}

const savePayment = function({ commit }) {
    commit('SAVE_PAYMENT')
    commit('CLEAR_PAYMENT')
    commit('SET_PAYMENT_METHOD', null)
}

const clearPayment = function({ commit }) {
    commit('CLEAR_PAYMENT')
}

const setPurchaseOrder = function({ commit }, payload) {
    commit('SET_PURCHASE_ORDER', payload)
}

const setInvoiceObservation = function({ commit }, payload) {
    commit('SET_INVOICE_OBSERVATION', payload)
}

const setBanks = async function({ commit }) {
    // console.log('estoy en setBanks"')
    let banks = await apiSale.fetchBanks()
    // console.log('banks.data', banks.data)
    commit('SET_BANKS', banks)
}

const submitSale = async function(
    { state, getters, rootState, dispatch },
    payloadCustomer
) {
    //FIXME: Integration Only
    //dispatch('printDTE', {
    //billNum: 1234,
    //eSignatureURL: null,
    //dateTime: null,
    //isEmployee: true,
    //})
    //return
    let counter = rootState.IntegrationModule
    let officeID = rootState.CustomerModule.activeOfficeID || 1
    if (state.posSaleType === 1) {
        counter = counter.ticketCounter
        if (isNaN(counter)) counter = parseInt(counter)
    } else if (state.posSaleType === 2) {
        counter = counter.invoiceTicketCounter
        if (isNaN(counter)) counter = parseInt(counter)
    }
    let arrp = state.arrayPayments.map(p => {
        if (p.paymentMethod === 4) {
            ;['accountNumber', 'plaza', 'serialNumber'].forEach(x => {
                if (p.paymentDetail[x])
                    p.paymentDetail[x] = parseInt(p.paymentDetail[x])
            })
        }
        return p
    })
    //ENDFIXME
    // SI ES CAMBIO NO PUEDE SER MULTITICKET
    if (state.multipleSaleTicket.length && state.multipleSaleTicket > 1) {
        if (
            state.multipleSaleTicket.some(
                t => t.changed_dte && t.changed_dte.dte_number
            )
        )
            throw 'No puede hacerse cambio y multiticket a la vez'
    }
    let customerCoreBusinessId = rootState.CustomerModule.coreBusinessSelected
        ? rootState.CustomerModule.coreBusinessSelected
        : payloadCustomer.gCoreBusinessSii &&
          payloadCustomer.gCoreBusinessSii.length
        ? payloadCustomer.gCoreBusinessSii[0].id
        : null
    let isChange =
        state.multipleSaleTicket[0].changed_dte &&
        state.multipleSaleTicket[0].changed_dte.dte_number

    let response = await apiSale.sendSale(
        state.ticketCode,
        getters.change,
        state.posSaleType,
        payloadCustomer.customerId,
        arrp,
        isChange ? 'SX' : state.payer,
        getters.roundingLaw,
        state.lastPaymentMethod === 1,
        state.oc,
        counter,
        officeID,
        state.invoiceObservation,
        getters.currentIdMultiTicket,
        getters.change,

        // TODO: Verificar que esto haya quedado bien
        customerCoreBusinessId,

        // rootState.CustomerModule.coreBusinessSelected ||
        //     payloadCustomer.mainGCoreBusiness_sii_id,
        state.switchMultipleTicket
    )
    return response
}

const printTicketReceipt = ({ rootState }) => {
    let companyData =
        rootState.SessionModule && rootState.SessionModule.companyData
            ? rootState.SessionModule.companyData
            : {
                  rut: '76.058.430-7',
                  commercial_business:
                      'COMPRA VENTA, DISTRIBUCION, REPRESETACION DE ARTICULOS DE PLASTICO, CARTONES Y P',
                  address: 'VICENTE ZORRILLA 835, LA SERENA',
                  business_name:
                      'IMPORTADORA COMERCIALIZADORA Y DISTRIBUIDORA AGROPLASTIC LTDA',
              }
}

const printDTE = async function(
    { state, getters, rootState, rootGetters },
    payload = {
        billNum: 1234,
        eSignatureURL: null,
        dateTime: null,
        isEmployee: false,
        isInternalConsumption: false,
        currentEnv: null,
        options: null,
    }
) {
    const fullName = ({ names, last_name1 }) => {
        return `${names} ${last_name1}`
    }
    let user = rootState.AuthModule.user

    let obj = {}
    obj.eSignatureURL = payload.eSignatureURL || null
    obj.isEmployee = payload.isEmployee
    if (payload.isEmployee)
        obj.saleEmployee =
            state.saleEmployee && state.saleEmployee.hr_employee
                ? fullName(state.saleEmployee.hr_employee)
                : ''

    let companyData =
        rootState.SessionModule && rootState.SessionModule.companyData
            ? rootState.SessionModule.companyData
            : {
                  rut: '76.058.430-7',
                  commercial_business:
                      'COMPRA VENTA, DISTRIBUCION, REPRESETACION DE ARTICULOS DE PLASTICO, CARTONES Y P',
                  address: 'VICENTE ZORRILLA 835, LA SERENA',
                  business_name:
                      'IMPORTADORA COMERCIALIZADORA Y DISTRIBUIDORA AGROPLASTIC LTDA',
                  sii_resolution_month: 86,
                  sii_resolution_year: 2005,
              }

    obj.title = companyData.business_name
    obj.resNumber = companyData.sii_resolution_month
    obj.resYear = companyData.sii_resolution_year
    obj.barcode = ''
    obj.subtitle =
        payload.currentEnv === 'open_factura'
            ? 'DOCUMENTO NO VÁLIDO CÓMO BOLETA'
            : 'BOLETA ELECTRÓNICA'
    obj.RUT = companyData.rut
    obj.billNum = payload.billNum
    obj.activities = companyData.commercial_business
    obj.address = companyData.address
    obj.phone = ''
    let office = `${rootGetters['AuthModule/branchOfficeName']} - ${rootGetters['AuthModule/branchOfficeAddress']}`
    obj.office = office.toUpperCase()
    obj.seller =
        state.seller && state.seller.hr_employee
            ? fullName(state.seller.hr_employee)
            : '-'
    obj.cashier = user && user.hr_employee ? fullName(user.hr_employee) : '-'
    obj.cashDesk = rootGetters['AuthModule/cashDeskID']

    if (!payload.dateTime) {
        obj.date = DateUtils.getDate()
        let t = new Date()
        obj.time = `${t.getHours()}:${t.getMinutes()}:${t.getSeconds()}`
    } else {
        let dt = payload.dateTime.split(' ')
        obj.date = dt[0]
        obj.time = dt[1]
    }

    if (
        state.multipleSaleTicket &&
        state.multipleSaleTicket.length === 1 &&
        state.multipleSaleTicket[0].changed_dte
    ) {
        obj.subtotal = getters.subTotal
        obj.total = getters.subTotal
        obj.change = payload.options ? payload.options.change || 0 : 0
        /*
            payload.options &&
            (payload.options.change || payload.options.change === 0)
                ? payload.options.change
                : getters.change ||
                  parseInt(getters.totalPaid) - getters.subTotal
                  */
    } else {
        obj.subtotal = getters.subTotal
        obj.total = getters.totalSale
        obj.change =
            payload.options && payload.options.change
                ? payload.options.change
                : getters.change || parseInt(getters.change)
    }

    obj.roundLaw =
        payload.options && payload.options.roundingLaw
            ? payload.options.roundingLaw
            : getters.roundingLaw
    obj.applyRoundLaw = state.lastPaymentMethod === 1
    obj.amountPaid = parseInt(getters.totalPaid)
    obj.discount = state.discountOrChargePercentage
    obj.amountDiscount = getters.amountDiscount

    obj.arrayPayments = state.arrayPayments

    obj.posSaleType = state.posSaleType
    obj.items = state.saleDetail
    obj.preventPrint = rootState.SessionModule.preventPrint
    obj.closeTimeout = process.env.VUE_APP_PRINTER_TIMEOUT

    /*
    let win =
        payload.currentEnv === 'open_factura'
            ? window.open('receip.html')
            : window.open('receipIntegration.html')
    */
    const resMonth = rootState.SessionModule.companyData
        ? rootState.SessionModule.companyData.sii_resolution_month || ''
        : ''

    const resYear = rootState.SessionModule.companyData
        ? rootState.SessionModule.companyData.sii_resolution_year || ''
        : ''

    // Print Service
    let srvObject = {
        company_name: rootState.SessionModule.companyData
            ? rootState.SessionModule.companyData.business_name || ''
            : '',
        header_rut: rootState.SessionModule.companyData
            ? rootState.SessionModule.companyData.rut || ''
            : '',
        header_subtitle:
            payload.currentEnv === 'open_factura'
                ? 'BOLETA ELECTRÓNICA'
                : 'DOCUMENTO NO VÁLIDO CÓMO BOLETA',
        header_footer:
            payload.currentEnv === 'open_factura'
                ? `Nro: ${payload.billNum}`
                : `TICKET DE VENTA N°: ${payload.billNum}`,
        business_title: '',
        business_commercial_business: rootState.SessionModule.companyData
            ? rootState.SessionModule.companyData.commercial_business || ''
            : '',
        business_address: rootState.SessionModule.companyData
            ? rootState.SessionModule.companyData.address || ''
            : '',
        business_branch_office:
            (rootGetters['AuthModule/branchOfficeName'] || '') +
            ' - ' +
            (rootGetters['AuthModule/branchOfficeAddress'] || ''),
        business_phone: '',
        business_seller:
            state.seller && state.seller.hr_employee
                ? fullName(state.seller.hr_employee)
                : '-',
        business_cashier:
            user && user.hr_employee ? fullName(user.hr_employee) : '-',
        business_cash_desk: rootGetters['AuthModule/cashDeskID'] + '',
        business_employee: '',
        sale_date_time: payload.dateTime || dateToYYYYMMDDHHmmSS(new Date()),
        detail_product_message: 'DETALLE DE VENTA',
        items: state.saleDetail,
        discount_text: '',
        total_subtotal: parseInt(getters.subTotal),
        total_discount_percentage:
            parseInt(getters.currentDiscountOrChargePercentage) || 0,
        total_discount:
            getters.amountDiscount && !getters.currentDiscountOrChargePercentage
                ? -1 * parseInt(getters.amountDiscount)
                : 0,
        total: parseInt(getters.saleTotal),
        total_iva: parseInt(parseInt(getters.saleTotal)*0.19),
        // total_neto: parseInt(parseInt(getters.saleTotal)*0.81),
        total_rounding_law: obj.roundLaw,
        total_to_pay:
            parseInt(getters.saleTotal) + parseInt(getters.saleRoundingLaw),
        sale_paid: parseInt(getters.salePaid),
        total_cash_change: obj.change,
        sale_payment_message: 'DETALLE DE PAGOS',
        sale_payments: state.arrayPayments,
        // signature_url: '',
        signature_url: payload.currentEnv === 'open_factura' ? payload.eSignatureURL : '',
        signature_title:
            payload.currentEnv === 'open_factura'
                ? 'TIMBRE ELECTRÓNICO SII'
                : '',
        signature_res:
            payload.currentEnv === 'open_factura'
                ? `Res.${resMonth} de ${resYear} Verifique documento: www.sii.cl`
                : '',
        footer_text: '',
    }
    if (
        state.multipleSaleTicket &&
        state.multipleSaleTicket.length === 1 &&
        state.multipleSaleTicket[0].changed_dte
    ) {
        srvObject.total = getters.subTotal
        srvObject.total_subtotal = getters.subTotal
        srvObject.cash_change =
            payload.options &&
            (payload.options.change || payload.options.change === 0)
                ? payload.options.change
                : getters.change ||
                  parseInt(getters.totalPaid) - getters.subTotal
    }

    if (rootState.SessionModule.htmlPrint) {
        let win = window.open(
            payload.currentEnv === 'open_factura'
                ? 'receip.html'
                : 'receipIntegration.html',
            '_blank'
        )
        /*
        let win =
            payload.currentEnv === 'open_factura'
                ? window.open('receip.html')
                : window.open('receipIntegration.html')
                */
        Object.assign(win.window, obj)
        return true
    }

    console.log('HTMLl', obj)
    console.log('SERVICE', srvObject)

    try {

        //
        // console.log({ obj, state })

        // console.log('FORMAT', printerApi.formatCashDeskReceipt(srvObject))
        // return
        let timeout = () =>
            new Promise((resolve, reject) => {
                setTimeout(
                    () => reject('Tiempo de espera agotado'),
                    process.env.VUE_APP_PRINTER_SERVICE_TIMEOUT
                        ? parseInt(process.env.VUE_APP_PRINTER_SERVICE_TIMEOUT)
                        : 8000
                )
            })
        let promise = Promise.race([
            printerApi.printCashDeskReceipt(srvObject),
            timeout(),
        ])
        //let printResponse = await printerApi.printCashDeskReceipt(srvObject)
        let printResponse = await promise
        return printResponse
    } catch (e) {
        let win = window.open(
            payload.currentEnv === 'open_factura'
                ? 'receip.html'
                : 'receipIntegration.html',
            '_blank'
        )
        //     payload.currentEnv === 'open_factura'
        //         ? 'receip.html'
        //         : 'receipIntegration.html',
        //     '_blank'
        // )
        /*
        let win =
            payload.currentEnv === 'open_factura'
                ? window.open('receip.html')
                : window.open('receipIntegration.html')
                */
        Object.assign(win.window, obj)
        return true
    }
}

const fetchSaleEmployee = async function({}, ticketCode) {
    return await apiSale.fetchSaleEmployee(ticketCode)
}

const setPayer = function({ commit }, readCode) {
    let payer = getTypePayer(readCode)
    commit('SET_PAYER', payer)
}

const deletePrefix = function({}, readCode) {
    const longCode = readCode.length
    const code = readCode.substr(2, longCode)
    return code
}

const getTypePayer = function(code) {
    let readCode = clone(code)
    let prefix = readCode.substr(0, 2)
    prefix = prefix.toUpperCase()
    //if (prefix === 'SX') prefix = 'SE'
    return prefix
}

const resetSale = function({ commit }) {
    commit('RESET_STATE')
}

const addMultipleSaleTicket = function({ commit }, saleTicket) {
    commit('ADD_MULTIPLE_SALE_TICKET', saleTicket)
}

const deleteMultipleSaleTicket = function({ commit }, saleTicket) {
    commit('SUBTRACT_SALE_MULTIPLE', saleTicket)
    commit('DELETE_MULTIPLE_SALE_TICKET', saleTicket)
}

const resetSaleAfterRemoveTicket = function({ commit }, newTotals) {
    commit('RESET_SALE_AFTER_REMOVE_TICKET', newTotals)
}

const setArrayPayments = ({ commit }, arrayPayments) =>
    commit('SET_ARRAY_PAYMENTS', arrayPayments)

const setIsChangeTicket = ({ commit }, val) =>
    commit('SET_IS_CHANGE_TICKET', val)

const setSwitchMultipleTicket = ({ commit }, val) =>
    commit('SET_SWITCH_MULTIPLE_TICKET', val)
export default {
    setSale,
    setPayment,
    setPaymentArray,
    resetCashDeskState,
    submitSale,
    setPaymentMethod,
    setSaleDetails,
    fetchSaleCustomer,
    annulSale,
    setSaleType,
    setPaymentDetail,
    setBanks,
    savePayment,
    clearPayment,
    setPayer,
    deletePrefix,
    fetchSaleEmployee,
    printDTE,
    resetSale,
    reprintDTE,
    setPurchaseOrder,
    //FIXME: integration only
    printVoucher,
    setInvoiceObservation,
    addMultipleSaleTicket,
    deleteMultipleSaleTicket,
    resetSaleAfterRemoveTicket,
    //EDNFIXME
    setArrayPayments,
    setIsChangeTicket,
    setSwitchMultipleTicket,
}
